import { FormControl, FormLabel, Grid } from '@mui/material'
import { TextField } from 'components/textField'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { AuthStore } from 'stores'

export interface IPasswordResetForm {
  authStore?:    AuthStore
  showPassword?: boolean
}

export const PasswordResetForm = inject(
  'authStore',
  'routingStore'
)(
  observer((props: IPasswordResetForm) => {
    const { t } = useTranslation()
    const { authStore } = props

    return (
      <>
        <Grid item xs={12} md={6}>
          <FormControl
            sx     = {{ display: 'flex', flexDirection: 'column' }}
            margin = 'normal'
          >
            <FormLabel>{t('current_password')}</FormLabel>
            <TextField
              hiddenLabel
              variant  = 'outlined'
              value    = {authStore.getCurUser.password}
              onChange = {(e) =>
                authStore.getCurUser.set('password', e.target.value, true)
              }
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl
            sx     = {{ display: 'flex', flexDirection: 'column' }}
            margin = 'normal'
          >
            <FormLabel>{t('new_password')}</FormLabel>
            <TextField
              hiddenLabel
              variant  = 'outlined'
              value    = {authStore.getCurUser.password}
              onChange = {(e) =>
                authStore.getCurUser.set('password', e.target.value, true)
              }
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl
            sx     = {{ display: 'flex', flexDirection: 'column' }}
            margin = 'normal'
          >
            <FormLabel>{t('confirm_new_password')}</FormLabel>
            <TextField
              fullWidth
              hiddenLabel
              variant  = 'outlined'
              value    = {authStore.getCurUser.password}
              onChange = {(e) =>
                authStore.getCurUser.set('password', e.target.value, true)
              }
            />
          </FormControl>
        </Grid>
      </>
    )
  })
)
